export default __webpack_public_path__ + "static/media/block-align-horizontally.26d98a69.svg";